import * as React from 'react'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
// @ts-ignore
import { withRouter } from 'next/router'

// @ts-ignore
import isMobile from '../helpers/isMobile'
// $FlowFixMe TypeScript import
import { actionCreators } from '../login'
// @ts-ignore
import MenuMobile from './MenuMobile'
// @ts-ignore
import MenuDesktop from './MenuDesktop'
import {
  chauffeurAdd,
  chauffeurDetail,
  chauffeurDocs,
  chauffeurEdit,
  chauffeursList,
  finished,
  finishedDetail,
  lspDocs,
  offerDetail,
  offers,
  pendingOffers,
  planned,
  plannedDetail,
  ratingsList,
  vehiclesList,
  vehicleDetail,
  vehicleDocs
  // @ts-ignore
} from '../routes'
import { NavLink as NavLinkType } from '../../types/Link'
// @ts-ignore
import { State } from '../store/reducer'
import { Role } from '../../types/Role'

function getRidesLink (roles: Role[]) {
  const offersLink = offers({ userRoles: roles })
  const plannedLink = planned({ userRoles: roles })
  const finishedLink = finished({ userRoles: roles })
  return [offersLink, plannedLink, finishedLink].find(link => link.canAccess)
}

interface StateToProps {
  isLoggedIn: boolean
  firstName: string | null
  links: NavLinkType[]
}

interface DispatchToProps {
  logout: typeof actionCreators.logout
}

export interface HeaderProps
  extends Partial<StateToProps>,
    Partial<DispatchToProps> {
  disableLinkToHome?: boolean
}

export const getMenuLinks = (
  roles: Role[],
  params: { lspId: string }
): NavLinkType[] => {
  const links = []
  const ridesListLink = getRidesLink(roles)
  const chauffeursListLink = chauffeursList({ userRoles: roles })
  const lspLink = lspDocs({
    userRoles: roles,
    qs: { id: params ? params.lspId : '' }
  })
  const vehiclesListLink = vehiclesList({ userRoles: roles })
  const ratingsListLink = ratingsList({ userRoles: roles })

  if (ridesListLink) {
    links.push({
      labelId: 'rides.title',
      link: ridesListLink,
      isSelectedMatchers: [
        finished(),
        finishedDetail({}),
        offerDetail({}),
        offers(),
        pendingOffers({}),
        planned(),
        plannedDetail({})
      ]
    })
  }
  if (chauffeursListLink.canAccess) {
    links.push({
      labelId: 'shared.chauffeurs',
      link: chauffeursListLink,
      isSelectedMatchers: [
        chauffeurAdd(),
        chauffeurDetail({}),
        chauffeurEdit({}),
        chauffeurDocs({}),
        chauffeursList()
      ]
    })
  }
  if (vehiclesListLink.canAccess) {
    links.push({
      labelId: 'shared.vehicles',
      link: vehiclesListLink,
      isSelectedMatchers: [vehiclesList(), vehicleDetail({}), vehicleDocs({})]
    })
  }
  if (lspLink.canAccess) {
    links.push({
      labelId: 'company.title',
      link: lspLink,
      isSelectedMatchers: [lspDocs()]
    })
  }
  if (ratingsListLink.canAccess) {
    links.push({
      labelId: 'ratings.title',
      link: ratingsListLink,
      isSelectedMatchers: [ratingsList()]
    })
  }
  return links
}

export class Header extends React.PureComponent<HeaderProps> {
  render () {
    return (
      <header>
        {isMobile() ? (
          <MenuMobile {...this.props} />
        ) : (
          <MenuDesktop {...this.props} />
        )}
      </header>
    )
  }
}

function mapStateToProps ({
  login: { isLoggedIn },
  me,
  lsp
}: State): StateToProps {
  return {
    isLoggedIn,
    firstName: me.first_name,
    links: getMenuLinks(me.roles, { lspId: lsp.id })
  }
}

function mapDispatchToProps (dispatch: Dispatch): DispatchToProps {
  return bindActionCreators(
    {
      logout: actionCreators.logout
    },
    dispatch
  )
}

export default compose<typeof Header>(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter
)(Header)
